import ApiServiceBase from "./apiServiceBase.js";

class epgAPI extends ApiServiceBase {
  constructor() {
    super();

    this.days = [
      "Domingo",
      "Lunes",
      "Martes",
      "Miércoles",
      "Jueves",
      "Viernes",
      "Sábado",
    ];
  }

  getEPG(url, priority, callback, errorCallback) {
    this.getFromUrl(
      url,
      (responseJson) => {
        const response = responseJson;
        if (response) {
          //console.log(response);
          callback(response);
        }
      },
      (errorJson) => {
        const error = errorJson;
        if (error) {
          console.log(error);
          errorCallback(error);
        }
      },
      priority
    );
  }

  getEventsForOffsetDay(events, offset) {
    var actualEvents = [];
    if (events !== undefined) {
      const timestamp = Math.floor(Date.now() / 1000);
      for (var i = 0; i < events.length; ++i) {
        if (
          this.isEventOffset(events[i].start, events[i].end, timestamp, offset)
        ) {
          actualEvents.push(events[i]);
        }
      }
    }
    return actualEvents;
  }

  getCurrentEventEPG(events) {
    if (events !== undefined) {
      const timestamp = Math.floor(Date.now() / 1000);
      for (var i = 0; i < events.length; ++i) {
        if (this.isEventActual(events[i].start, events[i].end, timestamp)) {
          return events[i];
        }
      }
    }
  }

  getFirstDayEvent(events) {
    if (events !== undefined && events.length > 0) {
      const dayToCheck = events.length === 1 ? 0 : 1;
      return this.timestampToDate(events[dayToCheck].start);
    }
  }

  isEventOffset(start, end, actual, offset) {
    const startDate = new Date(start * 1000);
    const startDay = startDate.getDate();

    const endDate = new Date(end * 1000);
    const endDay = endDate.getDate();

    const actualDate = new Date(actual * 1000);
    const actualDay = actualDate.getDate();

    return actualDay + offset === startDay || actualDay + offset === endDay;
  }

  isEventActual(start, end, actual) {
    return start <= actual && end >= actual;
  }

  timestampToDate(timestamp) {
    const date = new Date(timestamp * 1000);
    const startDay = date.getDate();
    const startDayText = this.days[date.getDay()];

    return startDayText + " " + startDay;
  }

  timestampToHoursMinutes(timestamp) {
    const date = new Date(timestamp * 1000);
    const hours = "0" + date.getHours();
    const minutes = "0" + date.getMinutes();

    // Will display time in 10:30 format
    return hours.substr(-2) + ":" + minutes.substr(-2);
  }
}

export default new epgAPI();
